// extracted by mini-css-extract-plugin
module.exports = {"root":"TestimonialsBlock_root__pkTxH"};